import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CONTAINER from "consts/responsive";
import Icons from "consts/svgIcons";
import styles from "./styles.module.scss";

const Footer = () => {
  const newDate = new Date()

  return (
    <Box className={styles.footer}>
      <Box
        sx={{ ...CONTAINER }}
        style={{ padding: 0, height: "100%" }}
      >
        <Grid container className={styles.container}>
          <Grid
            item
            xs={6}
            display={"flex"}
            alignItems={"center"}
            className={styles.textLeft}
          >
            Copyright {newDate.getFullYear()} – Buildcorp
          </Grid>
          <Grid item xs={6} className={styles.textRight} onClick={() => {
            window.location.href = 'https://buildcorp.sharepoint.com/ ';
          }}>
            Return to Intrabuild
            <Icons.ReturnIcon className={styles.iconReturn} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Footer;
